"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7203],{

/***/ 16767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_icons_arrow_right__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37233);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);




var UnderlineLink = function(param) {
    var href = param.href, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex justify-center small:justify-start items-start",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: href,
            prefetch: false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex items-center text-large-regular border-b border-darkTone gap-x-4 py-2 transition-all duration-300 group hover:text-highlight hover:pl-4 hover:pr-1", className !== null && className !== void 0 ? className : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-mono",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_icons_arrow_right__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: 20,
                        className: "transition-all group-hover:ml-2 duration-300"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UnderlineLink);


/***/ }),

/***/ 7203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_components_underline_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16767);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84539);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80621);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _lib_util_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44269);








var ContentContainer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var intersectionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(intersectionRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
    });
    var parts = (props === null || props === void 0 ? void 0 : (ref = props.imageLocation) === null || ref === void 0 ? void 0 : ref.split(" ")[1]) === "1/3" ? 33 : 66;
    var side = (props === null || props === void 0 ? void 0 : props.imageLocation) === "right 1/3" || (props === null || props === void 0 ? void 0 : props.imageLocation) === "right 3/5" ? "right" : "left";
    var ref6, ref7, ref8, _content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("relative transition w-full py-10 lg:py-[5vh]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("relative z-10 flex lg:gap-28 gap-10", {
                    "flex-col-reverse md:flex-row-reverse": side === "right",
                    "flex-col-reverse md:flex-row": side === "left"
                }),
                children: [
                    props.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("relative w-full aspect-[5/3] overflow-hidden", {
                            "lg:w-[40%]": parts === 33,
                            "lg:w-[60%]": parts === 66
                        }),
                        ref: intersectionRef,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
                            as: "div",
                            show: intersection && intersection.intersectionRatio >= 0.5 ? true : false,
                            className: "relative inset-0 w-full h-full",
                            enter: "transform transition duration-[400ms]",
                            enterFrom: "opacity-0 ".concat(side === "right" ? "translate-x-40" : "-translate-x-40"),
                            enterTo: "opacity-100 translate-x-0",
                            leave: "transform duration-200 delay-1000 transition ease-in-out",
                            leaveFrom: "opacity-100 rotate-0 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: [
                                (props === null || props === void 0 ? void 0 : props.caption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "absolute z-10 text-white ml-10 mt-10 font-semibold text-lg",
                                    dangerouslySetInnerHTML: {
                                        __html: (ref6 = props === null || props === void 0 ? void 0 : (ref1 = props.caption) === null || ref1 === void 0 ? void 0 : ref1.replaceAll("\n", "<br/>")) !== null && ref6 !== void 0 ? ref6 : ""
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    loader: _lib_util_loader__WEBPACK_IMPORTED_MODULE_7__/* .ImageLoader */ .S,
                                    src: props.image,
                                    loading: "lazy",
                                    priority: props === null || props === void 0 ? void 0 : props.preloadImage,
                                    layout: "fill",
                                    quality: 90,
                                    alt: props.imageAlt,
                                    className: "object-cover hover:shadow-outline w-full max-w-[70vw]",
                                    placeholder: typeof props.image === "string" ? "empty" : "blur"
                                })
                            ]
                        })
                    }),
                    (props === null || props === void 0 ? void 0 : props.title) !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("py-4 small:py-16 font-mono w-full flex flex-col justify-center text-darkTone", {
                            "px-4 small:px-8 md:pl-12 md:pr-0": side === "right",
                            "px-4 small:px-8 md:pl-0 md:pr-12": side !== "right",
                            "lg:w-[40%]": parts === 66,
                            "lg:w-[60%]": parts === 33
                        }),
                        children: [
                            props.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(props.titleTag, {
                                className: "text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl font-display font-base subpixel-antialiased mb-6",
                                children: props.title
                            }),
                            props.cta && (typeof ((ref2 = props.cta) === null || ref2 === void 0 ? void 0 : ref2.position) === "undefined" || ((ref3 = props.cta) === null || ref3 === void 0 ? void 0 : ref3.position) === "under title") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_components_underline_link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                href: props.cta.url,
                                children: props.cta.text
                            }),
                            typeof (props === null || props === void 0 ? void 0 : props.content) === "undefined" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("text-base-regular mb-6  mr-auto w-full", {
                                    "max-w-[32rem]": side !== "right"
                                }, {
                                    "max-w-[40rem]": side === "right"
                                }),
                                children: props.children
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("text-base-regular mb-6  mr-auto w-full", {
                                    "max-w-[32rem]": side !== "right"
                                }, {
                                    "max-w-[40rem]": side === "right"
                                }),
                                dangerouslySetInnerHTML: {
                                    __html: (ref7 = props === null || props === void 0 ? void 0 : props.content) !== null && ref7 !== void 0 ? ref7 : ""
                                }
                            }),
                            props.cta && ((ref4 = props.cta) === null || ref4 === void 0 ? void 0 : ref4.position) !== "under title" && typeof ((ref5 = props.cta) === null || ref5 === void 0 ? void 0 : ref5.position) !== "undefined" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_components_underline_link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                href: props.cta.url,
                                children: props.cta.text
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("py-16 font-mono w-full lg:w-[40%] flex flex-col justify-center", {
                            "px-8 md:pl-12 md:pr-0": side === "right"
                        }, {
                            "px-8 md:pl-0 md:pr-12": side !== "right"
                        }, {
                            "text-darkTone": ((ref8 = props === null || props === void 0 ? void 0 : props.background) !== null && ref8 !== void 0 ? ref8 : "dark") === "dark"
                        }, {
                            "text-darkTone": (props === null || props === void 0 ? void 0 : props.background) !== "dark"
                        }),
                        dangerouslySetInnerHTML: {
                            __html: (_content = props.content) !== null && _content !== void 0 ? _content : ""
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-0 pointer-events-none",
                style: {
                    background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                },
                children: "\xa0"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContentContainer);


/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ })

}]);